import { getNameInfo } from "../utilities/getNameInfo.js";
export async function appendText(fileCollection, relativePath, text, options = {}) {
    const source = await getExtendedSourceFromText(relativePath, text, options);
    await fileCollection.appendExtendedSource(source);
}
async function getExtendedSourceFromText(originalRelativePath, text, options = {}) {
    const { relativePath, name } = getNameInfo(originalRelativePath);
    const blob = new Blob([await text], { type: 'text/plain' });
    return {
        uuid: crypto.randomUUID(),
        relativePath,
        name,
        lastModified: options.dateModified || Date.now(),
        baseURL: 'ium:/',
        text: () => blob.text(),
        stream: () => blob.stream(),
        arrayBuffer: () => blob.arrayBuffer(),
    };
}
//# sourceMappingURL=appendText.js.map